module.exports = __webpack_public_path__ + "DK.png?a30053a733326e02595944c9997ec617";